var _excluded = ["mark", "encoding", "params", "projection"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isContinuousFieldOrDatumDef, isFieldOrDatumDef, title } from '../channeldef';
import { extractTransformsFromEncoding, normalizeEncoding } from '../encoding';
import * as log from '../log';
import { isMarkDef } from '../mark';
import { accessWithDatumToUnescapedPath, replaceAll, titleCase } from '../util';
import { CompositeMarkNormalizer } from './base';
import { compositeMarkContinuousAxis, compositeMarkOrient, getCompositeMarkTooltip, makeCompositeAggregatePartFactory } from './common';
export var ERRORBAR = 'errorbar';
export var ERRORBAR_PARTS = ['ticks', 'rule'];
export var errorBarNormalizer = new CompositeMarkNormalizer(ERRORBAR, normalizeErrorBar);
export function normalizeErrorBar(spec, _ref) {
  var config = _ref.config;
  // Need to initEncoding first so we can infer type
  spec = _objectSpread(_objectSpread({}, spec), {}, {
    encoding: normalizeEncoding(spec.encoding, config)
  });
  var _errorBarParams = errorBarParams(spec, ERRORBAR, config),
    transform = _errorBarParams.transform,
    continuousAxisChannelDef = _errorBarParams.continuousAxisChannelDef,
    continuousAxis = _errorBarParams.continuousAxis,
    encodingWithoutContinuousAxis = _errorBarParams.encodingWithoutContinuousAxis,
    ticksOrient = _errorBarParams.ticksOrient,
    markDef = _errorBarParams.markDef,
    outerSpec = _errorBarParams.outerSpec,
    tooltipEncoding = _errorBarParams.tooltipEncoding;
  delete encodingWithoutContinuousAxis.size;
  var makeErrorBarPart = makeCompositeAggregatePartFactory(markDef, continuousAxis, continuousAxisChannelDef, encodingWithoutContinuousAxis, config.errorbar);
  var thickness = markDef.thickness;
  var size = markDef.size;
  var tick = _objectSpread(_objectSpread({
    type: 'tick',
    orient: ticksOrient,
    aria: false
  }, thickness !== undefined ? {
    thickness: thickness
  } : {}), size !== undefined ? {
    size: size
  } : {});
  var layer = [].concat(_toConsumableArray(makeErrorBarPart({
    partName: 'ticks',
    mark: tick,
    positionPrefix: 'lower',
    extraEncoding: tooltipEncoding
  })), _toConsumableArray(makeErrorBarPart({
    partName: 'ticks',
    mark: tick,
    positionPrefix: 'upper',
    extraEncoding: tooltipEncoding
  })), _toConsumableArray(makeErrorBarPart({
    partName: 'rule',
    mark: _objectSpread({
      type: 'rule',
      ariaRoleDescription: 'errorbar'
    }, thickness !== undefined ? {
      size: thickness
    } : {}),
    positionPrefix: 'lower',
    endPositionPrefix: 'upper',
    extraEncoding: tooltipEncoding
  })));
  return _objectSpread(_objectSpread({}, outerSpec), {}, {
    transform: transform
  }, layer.length > 1 ? {
    layer: layer
  } : _objectSpread({}, layer[0]));
}
function errorBarOrientAndInputType(spec, compositeMark) {
  var encoding = spec.encoding;
  if (errorBarIsInputTypeRaw(encoding)) {
    return {
      orient: compositeMarkOrient(spec, compositeMark),
      inputType: 'raw'
    };
  }
  var isTypeAggregatedUpperLower = errorBarIsInputTypeAggregatedUpperLower(encoding);
  var isTypeAggregatedError = errorBarIsInputTypeAggregatedError(encoding);
  var x = encoding.x;
  var y = encoding.y;
  if (isTypeAggregatedUpperLower) {
    // type is aggregated-upper-lower
    if (isTypeAggregatedError) {
      throw new Error("".concat(compositeMark, " cannot be both type aggregated-upper-lower and aggregated-error"));
    }
    var x2 = encoding.x2;
    var y2 = encoding.y2;
    if (isFieldOrDatumDef(x2) && isFieldOrDatumDef(y2)) {
      // having both x, x2 and y, y2
      throw new Error("".concat(compositeMark, " cannot have both x2 and y2"));
    } else if (isFieldOrDatumDef(x2)) {
      if (isContinuousFieldOrDatumDef(x)) {
        // having x, x2 quantitative and field y, y2 are not specified
        return {
          orient: 'horizontal',
          inputType: 'aggregated-upper-lower'
        };
      } else {
        // having x, x2 that are not both quantitative
        throw new Error("Both x and x2 have to be quantitative in ".concat(compositeMark));
      }
    } else if (isFieldOrDatumDef(y2)) {
      // y2 is a FieldDef
      if (isContinuousFieldOrDatumDef(y)) {
        // having y, y2 quantitative and field x, x2 are not specified
        return {
          orient: 'vertical',
          inputType: 'aggregated-upper-lower'
        };
      } else {
        // having y, y2 that are not both quantitative
        throw new Error("Both y and y2 have to be quantitative in ".concat(compositeMark));
      }
    }
    throw new Error('No ranged axis');
  } else {
    // type is aggregated-error
    var xError = encoding.xError;
    var xError2 = encoding.xError2;
    var yError = encoding.yError;
    var yError2 = encoding.yError2;
    if (isFieldOrDatumDef(xError2) && !isFieldOrDatumDef(xError)) {
      // having xError2 without xError
      throw new Error("".concat(compositeMark, " cannot have xError2 without xError"));
    }
    if (isFieldOrDatumDef(yError2) && !isFieldOrDatumDef(yError)) {
      // having yError2 without yError
      throw new Error("".concat(compositeMark, " cannot have yError2 without yError"));
    }
    if (isFieldOrDatumDef(xError) && isFieldOrDatumDef(yError)) {
      // having both xError and yError
      throw new Error("".concat(compositeMark, " cannot have both xError and yError with both are quantiative"));
    } else if (isFieldOrDatumDef(xError)) {
      if (isContinuousFieldOrDatumDef(x)) {
        // having x and xError that are all quantitative
        return {
          orient: 'horizontal',
          inputType: 'aggregated-error'
        };
      } else {
        // having x, xError, and xError2 that are not all quantitative
        throw new Error('All x, xError, and xError2 (if exist) have to be quantitative');
      }
    } else if (isFieldOrDatumDef(yError)) {
      if (isContinuousFieldOrDatumDef(y)) {
        // having y and yError that are all quantitative
        return {
          orient: 'vertical',
          inputType: 'aggregated-error'
        };
      } else {
        // having y, yError, and yError2 that are not all quantitative
        throw new Error('All y, yError, and yError2 (if exist) have to be quantitative');
      }
    }
    throw new Error('No ranged axis');
  }
}
function errorBarIsInputTypeRaw(encoding) {
  return (isFieldOrDatumDef(encoding.x) || isFieldOrDatumDef(encoding.y)) && !isFieldOrDatumDef(encoding.x2) && !isFieldOrDatumDef(encoding.y2) && !isFieldOrDatumDef(encoding.xError) && !isFieldOrDatumDef(encoding.xError2) && !isFieldOrDatumDef(encoding.yError) && !isFieldOrDatumDef(encoding.yError2);
}
function errorBarIsInputTypeAggregatedUpperLower(encoding) {
  return isFieldOrDatumDef(encoding.x2) || isFieldOrDatumDef(encoding.y2);
}
function errorBarIsInputTypeAggregatedError(encoding) {
  return isFieldOrDatumDef(encoding.xError) || isFieldOrDatumDef(encoding.xError2) || isFieldOrDatumDef(encoding.yError) || isFieldOrDatumDef(encoding.yError2);
}
export function errorBarParams(spec, compositeMark, config) {
  var _outerSpec$transform;
  // TODO: use selection
  var mark = spec.mark,
    encoding = spec.encoding,
    params = spec.params,
    _p = spec.projection,
    outerSpec = _objectWithoutProperties(spec, _excluded);
  var markDef = isMarkDef(mark) ? mark : {
    type: mark
  };
  // TODO(https://github.com/vega/vega-lite/issues/3702): add selection support
  if (params) {
    log.warn(log.message.selectionNotSupported(compositeMark));
  }
  var _errorBarOrientAndInp = errorBarOrientAndInputType(spec, compositeMark),
    orient = _errorBarOrientAndInp.orient,
    inputType = _errorBarOrientAndInp.inputType;
  var _compositeMarkContinu = compositeMarkContinuousAxis(spec, orient, compositeMark),
    continuousAxisChannelDef = _compositeMarkContinu.continuousAxisChannelDef,
    continuousAxisChannelDef2 = _compositeMarkContinu.continuousAxisChannelDef2,
    continuousAxisChannelDefError = _compositeMarkContinu.continuousAxisChannelDefError,
    continuousAxisChannelDefError2 = _compositeMarkContinu.continuousAxisChannelDefError2,
    continuousAxis = _compositeMarkContinu.continuousAxis;
  var _errorBarAggregationA = errorBarAggregationAndCalculation(markDef, continuousAxisChannelDef, continuousAxisChannelDef2, continuousAxisChannelDefError, continuousAxisChannelDefError2, inputType, compositeMark, config),
    errorBarSpecificAggregate = _errorBarAggregationA.errorBarSpecificAggregate,
    postAggregateCalculates = _errorBarAggregationA.postAggregateCalculates,
    tooltipSummary = _errorBarAggregationA.tooltipSummary,
    tooltipTitleWithFieldName = _errorBarAggregationA.tooltipTitleWithFieldName;
  var _ref2 = continuousAxis === 'x' ? 'x2' : 'y2',
    _ref3 = continuousAxis === 'x' ? 'xError' : 'yError',
    _ref4 = continuousAxis === 'x' ? 'xError2' : 'yError2',
    oldContinuousAxisChannelDef = encoding[continuousAxis],
    oldContinuousAxisChannelDef2 = encoding[_ref2],
    oldContinuousAxisChannelDefError = encoding[_ref3],
    oldContinuousAxisChannelDefError2 = encoding[_ref4],
    oldEncodingWithoutContinuousAxis = _objectWithoutProperties(encoding, [continuousAxis, _ref2, _ref3, _ref4].map(_toPropertyKey));
  var _extractTransformsFro = extractTransformsFromEncoding(oldEncodingWithoutContinuousAxis, config),
    bins = _extractTransformsFro.bins,
    timeUnits = _extractTransformsFro.timeUnits,
    oldAggregate = _extractTransformsFro.aggregate,
    oldGroupBy = _extractTransformsFro.groupby,
    encodingWithoutContinuousAxis = _extractTransformsFro.encoding;
  var aggregate = [].concat(_toConsumableArray(oldAggregate), _toConsumableArray(errorBarSpecificAggregate));
  var groupby = inputType !== 'raw' ? [] : oldGroupBy;
  var tooltipEncoding = getCompositeMarkTooltip(tooltipSummary, continuousAxisChannelDef, encodingWithoutContinuousAxis, tooltipTitleWithFieldName);
  return {
    transform: [].concat(_toConsumableArray((_outerSpec$transform = outerSpec.transform) !== null && _outerSpec$transform !== void 0 ? _outerSpec$transform : []), _toConsumableArray(bins), _toConsumableArray(timeUnits), _toConsumableArray(aggregate.length === 0 ? [] : [{
      aggregate: aggregate,
      groupby: groupby
    }]), _toConsumableArray(postAggregateCalculates)),
    groupby: groupby,
    continuousAxisChannelDef: continuousAxisChannelDef,
    continuousAxis: continuousAxis,
    encodingWithoutContinuousAxis: encodingWithoutContinuousAxis,
    ticksOrient: orient === 'vertical' ? 'horizontal' : 'vertical',
    markDef: markDef,
    outerSpec: outerSpec,
    tooltipEncoding: tooltipEncoding
  };
}
function errorBarAggregationAndCalculation(markDef, continuousAxisChannelDef, continuousAxisChannelDef2, continuousAxisChannelDefError, continuousAxisChannelDefError2, inputType, compositeMark, config) {
  var errorBarSpecificAggregate = [];
  var postAggregateCalculates = [];
  var continuousFieldName = continuousAxisChannelDef.field;
  var tooltipSummary;
  var tooltipTitleWithFieldName = false;
  if (inputType === 'raw') {
    var center = markDef.center ? markDef.center : markDef.extent ? markDef.extent === 'iqr' ? 'median' : 'mean' : config.errorbar.center;
    var extent = markDef.extent ? markDef.extent : center === 'mean' ? 'stderr' : 'iqr';
    if (center === 'median' !== (extent === 'iqr')) {
      log.warn(log.message.errorBarCenterIsUsedWithWrongExtent(center, extent, compositeMark));
    }
    if (extent === 'stderr' || extent === 'stdev') {
      errorBarSpecificAggregate = [{
        op: extent,
        field: continuousFieldName,
        as: "extent_".concat(continuousFieldName)
      }, {
        op: center,
        field: continuousFieldName,
        as: "center_".concat(continuousFieldName)
      }];
      postAggregateCalculates = [{
        calculate: "".concat(accessWithDatumToUnescapedPath("center_".concat(continuousFieldName)), " + ").concat(accessWithDatumToUnescapedPath("extent_".concat(continuousFieldName))),
        as: "upper_".concat(continuousFieldName)
      }, {
        calculate: "".concat(accessWithDatumToUnescapedPath("center_".concat(continuousFieldName)), " - ").concat(accessWithDatumToUnescapedPath("extent_".concat(continuousFieldName))),
        as: "lower_".concat(continuousFieldName)
      }];
      tooltipSummary = [{
        fieldPrefix: 'center_',
        titlePrefix: titleCase(center)
      }, {
        fieldPrefix: 'upper_',
        titlePrefix: getTitlePrefix(center, extent, '+')
      }, {
        fieldPrefix: 'lower_',
        titlePrefix: getTitlePrefix(center, extent, '-')
      }];
      tooltipTitleWithFieldName = true;
    } else {
      var centerOp;
      var lowerExtentOp;
      var upperExtentOp;
      if (extent === 'ci') {
        centerOp = 'mean';
        lowerExtentOp = 'ci0';
        upperExtentOp = 'ci1';
      } else {
        centerOp = 'median';
        lowerExtentOp = 'q1';
        upperExtentOp = 'q3';
      }
      errorBarSpecificAggregate = [{
        op: lowerExtentOp,
        field: continuousFieldName,
        as: "lower_".concat(continuousFieldName)
      }, {
        op: upperExtentOp,
        field: continuousFieldName,
        as: "upper_".concat(continuousFieldName)
      }, {
        op: centerOp,
        field: continuousFieldName,
        as: "center_".concat(continuousFieldName)
      }];
      tooltipSummary = [{
        fieldPrefix: 'upper_',
        titlePrefix: title({
          field: continuousFieldName,
          aggregate: upperExtentOp,
          type: 'quantitative'
        }, config, {
          allowDisabling: false
        })
      }, {
        fieldPrefix: 'lower_',
        titlePrefix: title({
          field: continuousFieldName,
          aggregate: lowerExtentOp,
          type: 'quantitative'
        }, config, {
          allowDisabling: false
        })
      }, {
        fieldPrefix: 'center_',
        titlePrefix: title({
          field: continuousFieldName,
          aggregate: centerOp,
          type: 'quantitative'
        }, config, {
          allowDisabling: false
        })
      }];
    }
  } else {
    if (markDef.center || markDef.extent) {
      log.warn(log.message.errorBarCenterAndExtentAreNotNeeded(markDef.center, markDef.extent));
    }
    if (inputType === 'aggregated-upper-lower') {
      tooltipSummary = [];
      postAggregateCalculates = [{
        calculate: accessWithDatumToUnescapedPath(continuousAxisChannelDef2.field),
        as: "upper_".concat(continuousFieldName)
      }, {
        calculate: accessWithDatumToUnescapedPath(continuousFieldName),
        as: "lower_".concat(continuousFieldName)
      }];
    } else if (inputType === 'aggregated-error') {
      tooltipSummary = [{
        fieldPrefix: '',
        titlePrefix: continuousFieldName
      }];
      postAggregateCalculates = [{
        calculate: "".concat(accessWithDatumToUnescapedPath(continuousFieldName), " + ").concat(accessWithDatumToUnescapedPath(continuousAxisChannelDefError.field)),
        as: "upper_".concat(continuousFieldName)
      }];
      if (continuousAxisChannelDefError2) {
        postAggregateCalculates.push({
          calculate: "".concat(accessWithDatumToUnescapedPath(continuousFieldName), " + ").concat(accessWithDatumToUnescapedPath(continuousAxisChannelDefError2.field)),
          as: "lower_".concat(continuousFieldName)
        });
      } else {
        postAggregateCalculates.push({
          calculate: "".concat(accessWithDatumToUnescapedPath(continuousFieldName), " - ").concat(accessWithDatumToUnescapedPath(continuousAxisChannelDefError.field)),
          as: "lower_".concat(continuousFieldName)
        });
      }
    }
    var _iterator = _createForOfIteratorHelper(postAggregateCalculates),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var postAggregateCalculate = _step.value;
        tooltipSummary.push({
          fieldPrefix: postAggregateCalculate.as.substring(0, 6),
          titlePrefix: replaceAll(replaceAll(postAggregateCalculate.calculate, "datum['", ''), "']", '')
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return {
    postAggregateCalculates: postAggregateCalculates,
    errorBarSpecificAggregate: errorBarSpecificAggregate,
    tooltipSummary: tooltipSummary,
    tooltipTitleWithFieldName: tooltipTitleWithFieldName
  };
}
function getTitlePrefix(center, extent, operation) {
  return "".concat(titleCase(center), " ").concat(operation, " ").concat(extent);
}